import { COUNT_LABEL } from "../lib/refdata";

/** Today's six targets, grouped by where the work is: leads, clients, team. */
const GROUPS: { label: string; keys: string[] }[] = [
  { label: "Leads", keys: ["outreach", "follow_ups", "appointments"] },
  { label: "Clients", keys: ["client_moves"] },
  { label: "Team", keys: ["recruit_moves", "builder_moves"] },
];

export function TargetDials({ score }: { score: any }) {
  if (!score) return null;
  return (
    <div className="cc-targets" aria-label="Today's targets">
      {GROUPS.map((g) => (
        <div key={g.label} className="cc-tgroup">
          <span className="cc-tlabel">{g.label}</span>
          <div className="cc-tdials">{g.keys.map((k) => <Dial key={k} label={COUNT_LABEL[k as keyof typeof COUNT_LABEL]} value={score[k] ?? 0} target={score[`t_${k}`] ?? 0} off={!score.targets_on} />)}</div>
        </div>
      ))}
    </div>
  );
}

export function Dial({ label, value, target, off }: { label: string; value: number; target: number; off?: boolean }) {
  const r = 26, c = 2 * Math.PI * r;
  const pct = target > 0 ? Math.min(1, value / target) : value > 0 ? 1 : 0;
  const met = target > 0 && value >= target;
  const color = off ? "#6a6b88" : met ? "#4fd1a1" : "var(--gold-2)";
  return (
    <div className="dial" title={`${label}: ${value}${target ? ` of ${target}` : ""}`}>
      <svg width="64" height="64" viewBox="0 0 64 64">
        <circle cx="32" cy="32" r={r} fill="none" stroke="rgba(255,255,255,.12)" strokeWidth="5" />
        <circle cx="32" cy="32" r={r} fill="none" stroke={color} strokeWidth="5" strokeLinecap="round"
          strokeDasharray={`${pct * c} ${c}`} transform="rotate(-90 32 32)" />
        <text x="32" y="31" textAnchor="middle" fontSize="16" fontWeight="600" fill="#fff" fontFamily="Fraunces, Georgia, serif">{value}</text>
        <text x="32" y="45" textAnchor="middle" fontSize="10" fill="#b9bbdd">{target ? `of ${target}` : off ? "off" : "bonus"}</text>
      </svg>
      <span className="lbl">{label}</span>
    </div>
  );
}

